import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapPin } from "lucide-react";
import api from "../lib/api";

// Gold marker icon
const goldIcon = new L.DivIcon({
  className: "",
  html: `<div style="width:28px;height:28px;background:#D4AF37;border:2px solid #0A2342;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.4)"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0A2342" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-8 12-8 12s-8-7.007-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  popupAnchor: [0, -30],
});

const CURR_LABEL = { INR: "₹" };
function fmtPrice(inr) {
  if (inr >= 10000000) return `₹${(inr / 10000000).toFixed(2)} Cr`;
  if (inr >= 100000) return `₹${(inr / 100000).toFixed(2)} L`;
  return `₹${inr.toLocaleString()}`;
}

export default function PropertyMap() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/properties").then((r) => setItems(r.data.filter((p) => p.lat && p.lng))).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  const center = [12.97, 77.59]; // Bengaluru center

  return (
    <div className="w-full h-[500px] border border-[#EDE6D3]/15 overflow-hidden [&_.leaflet-tile-pane]:brightness-[0.6] [&_.leaflet-tile-pane]:invert [&_.leaflet-tile-pane]:contrast-[3] [&_.leaflet-tile-pane]:hue-rotate-[200deg] [&_.leaflet-tile-pane]:saturate-[0.3]" data-testid="property-map">
      <MapContainer center={center} zoom={11} style={{ width: "100%", height: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org">OpenStreetMap</a>'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {items.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]} icon={goldIcon}>
            <Popup>
              <div style={{ minWidth: 200, fontFamily: "Montserrat, sans-serif" }}>
                <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4, color: "#0A2342" }}>{p.title}</div>
                <div style={{ fontSize: 11, color: "#6b6b6b", marginBottom: 6 }}>{p.location} · {p.type}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#D4AF37", marginBottom: 8 }}>{fmtPrice(p.price_inr)}</div>
                <div style={{ fontSize: 11, color: "#6b6b6b" }}>{p.area_sqft.toLocaleString()} sqft{p.yield_pct ? ` · ${p.yield_pct}% yield` : ""}</div>
                <a href={`/properties/${p.id}`} style={{ display: "inline-block", marginTop: 8, fontSize: 11, color: "#0A2342", textDecoration: "underline" }}>View Dossier →</a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
